import axios from "axios";
import { getEnvVariables } from "../helpers";

const { REACT_APP_API_URL } = getEnvVariables();

const anamApi = axios.create({
  baseURL: REACT_APP_API_URL,
});

anamApi.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");

  config.headers = {
    ...config.headers,
    ...(token ? { Authorization: token } : {}),
  };

  return config;
});

/**
 * Get Anam AI session token from backend
 * @returns {Promise<{sessionToken: string}>}
 */
export const getAnamSessionToken = async () => {
  try {
    const { data } = await anamApi.post('/anam/session-token');
    return data;
  } catch (error) {
    const errorMessage =
      error?.response?.data?.message ||
      error?.response?.data?.error ||
      error?.message ||
      'Failed to get Anam session token';
    const apiError = new Error(errorMessage);
    apiError.status = error?.response?.status;
    throw apiError;
  }
};

